import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/caregiver-tags')({
    component: CaregiverTagsPage,
});

function CaregiverTagsPage() {
    return <Navigate to="/settings" replace={true} />;
}
